import { useParams } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import FormGenerator from "../../plugins/formGenerator/form";

export default function LoadOrdersDetails() {
  const { id } = useParams<{ id: string }>();

  return (
    <>
      <PageMeta title="Assign Load | Admin Carriers" description="" />
      <div>
        <FormGenerator
          formId="loadorders"
          formIntData={{
            detailsPage: "details",
            idShow: true,
            detailsPageId: true,
            id: id,
          }}
        />
      </div>
    </>
  );
}
